module.exports = __webpack_public_path__ + "static/img/wechat-code.5a784c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mfooter/wechat-code.png
// module id = bpRR
// module chunks = 1